import React, { Fragment, useState } from 'react'
import { Dialog, Transition } from '@headlessui/react'

const KeyShortcutSidebar = ({ active, setActive }) => {
    const [enabled, setEnabled] = useState(false);

    return (
        <div>
            <Transition.Root show={active} as={Fragment}>
                <Dialog as="div" className="relative z-10" onClose={setActive}>
                    <div className="fixed inset-0 bg-[#c1c9d2b3]" />

                    <div className="fixed inset-0 overflow-hidden">
                        <div className="absolute inset-0 overflow-hidden">
                            <div className="pointer-events-none fixed inset-y-0 right-0 flex max-w-full pl-10">
                                <Transition.Child
                                    as={Fragment}
                                    enter="ease-out duration-300"
                                    enterFrom="opacity-0"
                                    enterTo="opacity-100"
                                    leave="ease-in duration-200"
                                    leaveFrom="opacity-100"
                                    leaveTo="opacity-0"
                                >
                                    <div className="fixed inset-0 bg-[#c1c9d2b3]" />
                                </Transition.Child>
                                <Transition.Child
                                    as={Fragment}
                                    enter="transform transition ease-in-out duration-500 sm:duration-700"
                                    enterFrom="translate-x-full"
                                    enterTo="translate-x-0"
                                    leave="transform transition ease-in-out duration-500 sm:duration-700"
                                    leaveFrom="translate-x-0"
                                    leaveTo="translate-x-full"

                                >
                                    <Dialog.Panel className="pointer-events-auto w-screen max-w-2xl">
                                        <div className="flex h-full flex-col overflow-y-scroll bg-white shadow-xl">
                                            <div className='font-semibold p-[16px_20px] border-b-[1px] border-[#ebeef1] text-base text-gray-900'>
                                                <span>Keyboard shortcuts</span>
                                                <div onClick={() => setActive(false)}></div>
                                            </div>
                                            <div className="relative flex-1 p-[24px] text-[#414552]">
                                                <div className="relative overflow-hidden">
                                                    <div className="flex">
                                                        <label className="inline-flex relative items-center mr-5 gap-2 cursor-pointer">
                                                            <input
                                                                type="checkbox"
                                                                className="sr-only peer"
                                                                checked={enabled}
                                                                readOnly
                                                            />
                                                            <div
                                                                onClick={() => { setEnabled(!enabled) }}
                                                                className="w-[30px] h-[15px] bg-gray-200 rounded-full peer peer-focus:ring-[#635bff] peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[4px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-[13px] after:w-[13px] after:transition-all peer-checked:bg-[#635bff]"
                                                            ></div>
                                                            <span className='text-[14px] font-medium select-none' onClick={() => { setEnabled(!enabled) }}>Enable keyboard shortcuts</span>
                                                        </label>
                                                    </div>
                                                </div>
                                                <div className="mt-8">
                                                    <h3 className='text-[16px] font-semibold'>Application</h3>
                                                    <div className='flex flex-col gap-1 mt-3'>
                                                        <div className="flex gap-1 items-center">
                                                            <div className="bg-[#f2f4f7] px-[8px] h-[20px] text-[13px] flex justify-center items-center rounded">c</div>
                                                            <div className="bg-[#f2f4f7] px-[8px] h-[20px] text-[13px] flex justify-center items-center rounded">f1</div>
                                                            <span className='text-sm ml-1'>Keyboard shortcuts</span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </Dialog.Panel>
                                </Transition.Child>
                            </div>
                        </div>
                    </div>
                </Dialog>
            </Transition.Root>
        </div>
    )
}

export default KeyShortcutSidebar